module.exports = __webpack_public_path__ + "img/3.a185a781.png";